import { H2, P3 } from '@/lib/shared/components/Typography';

import { clsx } from 'clsx';
import Image from 'next/image';

import styles from '../CompanyValues.module.scss';

interface ITab {
  title: string;
  prediction: string;
  contentClassName?: string;
  secondaryTitle?: string;
  isAloneCard?: boolean;
  theme?: 'light' | 'dark';
  className?: string;
}

export const CompanyValuesCard = ({
  title,
  prediction,
  contentClassName,
  className,
  secondaryTitle,
  isAloneCard = false,
  theme = 'dark',
}: ITab) => {
  return (
    <div
      className={clsx(
        className,
        styles.customerFocus,
        theme === 'dark'
          ? styles['customerFocus--dark']
          : styles['customerFocus--light']
      )}
    >
      <Image
        sizes="(max-width: 996px) 249px, 560px"
        className={styles.customerFocus__desctopLeftLeaf}
        width={551}
        height={421}
        src={'/images/complex/invest/left-leaf.webp'}
        alt=""
      />
      <Image
        sizes="(max-width: 996px) 249px, 560px"
        width={610}
        height={421}
        className={styles.customerFocus__desctopRightLeaf}
        src={'/images/complex/invest/right-leaf.webp'}
        alt=""
      />
      <div
        className={clsx(
          isAloneCard
            ? styles['customerFocus__mobLeftLeaf--alone']
            : styles.customerFocus__mobLeftLeaf
        )}
      >
        <Image
          sizes="(max-width: 996px) 482px, 560px"
          width={421}
          height={171}
          src={'/leaves/single-leaf.webp'}
          alt=""
        />
      </div>

      <div
        className={clsx(
          isAloneCard
            ? styles['customerFocus__mobRightLeaf--alone']
            : styles.customerFocus__mobRightLeaf
        )}
      >
        <Image
          sizes="(max-width: 996px) 608px, 560px"
          width={489}
          height={199}
          src={'/leaves/single-leaf.webp'}
          alt=""
        />
      </div>

      <div className={clsx(styles.customerFocus__content, contentClassName)}>
        <H2 className={styles.customerFocus__title}>{title}</H2>
        {secondaryTitle && (
          <H2 className={styles.customerFocus__title}>{secondaryTitle}</H2>
        )}
        <P3>{prediction}</P3>
      </div>
    </div>
  );
};
